import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
// import { store } from "@/store/store";

//baseURL: `${process.env.BASE_API_URL}/api`,

const api: AxiosInstance = axios.create({
  // baseURL: "https://9bmxfmmohe.execute-api.ap-northeast-1.amazonaws.com/api",
  baseURL: "https://p5lqsaz19e.execute-api.ap-northeast-1.amazonaws.com/api",
  headers: {
    "Content-Type": "application/json",
    // "Content-Type": "multipart/form-data",
  },
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFTOKEN",
});

const http = { api: api };

export default http;
